import React, { useMemo } from "react"

import { PoliciesListType } from "@common-shared/config/oneVerify/oneVerifyPolicies.config"
import { IPoliciesListFiltersData } from "@common-shared/types/policies.types"

import { ButtonElement } from "@front-shared/elements/button.element"

import { GENERAL_CONFIG } from "../../../../config/general.config"
import { ROUTES_CONFIG } from "../../../../config/routes.config"
import { PoliciesListHelper } from "../../../../helpers/policiesList.helper"
import { useAppSelector } from "../../../../store/selectors/app.selector"
import { policiesSelector } from "../../../../store/selectors/policies.selector"

export const FindSimilarButtonPolicyButton: React.FunctionComponent<
    IFindSimilarButtonPolicyButtonProps
> = props => {
    const { selectedItem } = useAppSelector(policiesSelector)

    const similarPoliciesUrl = useMemo<string | null>(() => {
        const { coverageResult } = selectedItem || {}

        if (
            !coverageResult?.groupName &&
            !coverageResult?.planName &&
            !coverageResult?.groupId
        ) {
            return null
        }

        const filtersData: IPoliciesListFiltersData = {
            ...PoliciesListHelper.getDefaultFiltersConfiguration(
                props.listType,
            ),

            groupId: coverageResult.groupId || undefined,
            groupName: coverageResult.groupName || undefined,
            planName: coverageResult.planName || undefined,
        }

        const searchParams = new URLSearchParams()

        searchParams.set(
            GENERAL_CONFIG.urlSearchParamsKeys.filters,
            JSON.stringify(filtersData),
        )

        return `${ROUTES_CONFIG.reportsUrl}?${searchParams.toString()}`
    }, [selectedItem, props.listType])

    return similarPoliciesUrl ? (
        <div className={props.className}>
            <a href={similarPoliciesUrl} target="_blank" rel="noreferrer">
                <ButtonElement
                    htmlType="button"
                    type="default"
                    label="Find Similar Policies"
                    buttonClassName="sm:w-full"
                    disabled={props.disabled}
                />
            </a>
        </div>
    ) : null
}

interface IFindSimilarButtonPolicyButtonProps {
    className?: string
    listType: PoliciesListType
    disabled?: boolean
}
